module.exports = __webpack_public_path__ + "img/drip-feed-pink.55e78b68.svg";